import {ActionIcon, Button, Paper} from "@mantine/core";
import {DataTable} from "mantine-datatable";
import { ArrowClockwiseIcon, PaperPlaneRightIcon, TrashIcon} from "@phosphor-icons/react";
import {useCallback, useContext, useEffect, useState} from "react";
import {Link} from "react-router";
import withRouteErrorBoundary from "../../../components/ErrorBoundary/withRouteErrorBoundary.tsx";
import LoaderIndicator from "../../../components/Loader/LoaderIndicator.tsx";
import Page from "../../../components/Page/Page.tsx";
import MessageContext from "../../../context/MessageContext.tsx";
import api from '../../../utils/api.ts';
import {Row} from '../../../components/Flex/Flex';
import {bodyReward, bodyType} from "./Formatters.jsx";
import SwitchTab from "./SwitchTab.jsx";


function CompleteList() {
    const {success,error} = useContext(MessageContext);
    const [contracts, setContracts] = useState(null);
    const [selected, setSelected] = useState([]);
    const [networks, setNetworks] = useState([]);


    useEffect(() => {
        api.get('/bh/contracts/complete').then(res => {
            setContracts(res.data);
        })
        api.get('/data/factions/bh').then(res => {
            setNetworks(res.data.sort((a,b) => a.name.localeCompare(b.name)));
        })
    }, []);


    const bodyActions = useCallback(row => {
        return (
            <Row mb={0}>
                <ActionIcon variant="light" radius="xl" onClick={() => {
                    api.post('/bh/contract/' + row.id+'/active').then(() => {
                        success('Contract reset', 'Contract is now active again');
                        setContracts(prev => {
                            let next = [...prev];
                            return next.filter(c => c.id !== row.id);
                        })
                    }).catch(err => {
                        if(err.response.data) {
                            error('Reset Failed', err.response.data.error);
                        }
                    })
                }} title="Reset to active">
                    <ArrowClockwiseIcon size={16}/>
                </ActionIcon>
                <ActionIcon variant="light" radius="xl" onClick={() => {
                    if (confirm('Are you sure you want to delete this contract? You will lose all scan data')) {
                        api.delete('/bh/contract/' + row.id).then(() => {
                            setContracts(prev => {
                                let next = [...prev];
                                return next.filter(c => c.id !== row.id);
                            })
                        })
                    }
                }} title="Delete Contract">
                    <TrashIcon size={16}/>
                </ActionIcon>
            </Row>
        )
    }, []);
    const bodyName = useCallback(row => {
        return <Link className="contract-name" to={`/bh/contract/${row.id}`}>{row.name}</Link>;
    }, []);

    const bodyNetwork = useCallback(row => {
        let network = networks.find(n => n.id === row.network);
        if(row.network && !network) {
            return <i>Dissolved</i>
        }
        return network?.name;
    }, [networks]);

    if (contracts === null) {
        return (<Page>
            <LoaderIndicator id="page-load" message="Loading contracts"/>
        </Page>)
    }



    return (
        <Page>
            <title>Completed Contracts</title>
            <SwitchTab
                left={<h2 className="m-0">Complete Contracts ({contracts.length})</h2>}
                right={<Button leftSection={<PaperPlaneRightIcon size={16}/>} disabled={selected.length === 0} onClick={() =>  {
                    api.post('/bh/contract/reward', {contracts: selected}).then(res => {
                        success('Contracts rewarded', res.data.count+' contracts have been marked as rewarded');
                        setContracts(res.data.data);
                    })
                }}>Mark selected as complete</Button>}
            />
            <Paper>
                <DataTable
                    records={contracts}
                    idAccessor="id"
                    selectedRecords={selected}
                    onSelectedRecordsChange={setSelected}
                    columns={[
                        {accessor: 'name', title: 'Target Name', sortable: true, render: row => bodyName(row)},
                        {accessor: 'network', title: 'Network', render: row => bodyNetwork(row)},
                        {accessor: 'difficulty', title: 'Difficulty'},
                        {accessor: 'type', title: 'Type', render: row => bodyType(row)},
                        {accessor: 'reward', title: 'Reward', render: row => bodyReward(row)},
                        {accessor: 'notes', title: 'Notes'},
                        {accessor: 'actions', title: 'Actions', render: row => bodyActions(row)},
                    ]}
                />
            </Paper>
        </Page>
    );


}

export default withRouteErrorBoundary(CompleteList);
